import styled from 'styled-components';

export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #f0f0f0;
  display: flex;
  gap: 20px;
  transition: box-shadow 0.3s ease;
  position: relative;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  }
`;

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  min-width: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;

  img {
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  svg {
    width: 40px;
    height: 40px;
  }
`;

export const ContentSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const HeaderSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const TitleSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const BadgesWrapper = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Badge = styled.span`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  background-color: ${({ $type }) => {
    if ($type === 'status-enabled') return '#e7f3ff';
    if ($type === 'status-disabled') return '#f5f5f5';
    return '#e8f5e9';
  }};
  color: ${({ $type }) => {
    if ($type === 'status-enabled') return '#007bff';
    if ($type === 'status-disabled') return '#6c757d';
    return '#4caf50';
  }};
`;

export const ActionsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const ActionButton = styled.button`
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    background-color: ${({ $delete }) => ($delete ? '#fff5f5' : '#f0f5ff')};
    border-color: ${({ $delete }) => ($delete ? '#FB2C36' : '#2D6CDF')};
  }

  &:active {
    transform: scale(0.95);
  }
`;

export const Description = styled.p`
  font-size: 14px;
  color: #6c757d;
  margin: 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FeaturesTitle = styled.h4`
  font-size: 13px;
  font-weight: 600;
  color: #666;
  margin: 0;
`;

export const FeaturesList = styled.ul`
  margin: 0;
  padding-left: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FeatureItem = styled.li`
  font-size: 13px;
  color: #333;
  line-height: 1.5;

  &::marker {
    color: #2d6cdf;
  }
`;

export const PriceSection = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DiscountedPrice = styled.span`
  font-size: 13px;
  color: #999;
`;

export const CurrentPrice = styled.span`
  font-size: 20px;
  font-weight: 700;
  color: #2d6cdf;
`;

export const CountText = styled.span`
  font-size: 13px;
  color: #666;
`;
